module.exports = __webpack_public_path__ + "/images/ico-primary-euro.35f7e1d.svg";